import AccessSettingsForm from './component'

export default AccessSettingsForm
